import React, { useEffect } from 'react';
import { fetchBenefits } from 'actions/Benefits';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'react-router-redux';

import { ListItem, Divider } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import filter from 'lodash/filter';
import map from 'lodash/map';

import KFlatButton from 'components/KJRN/KFlatButton';
import styles from 'styles/TBenefits';
import TLoading from './TLoading';
import TMessage from './TMessage';

const TBenefits = () => {
  const dispatch = useDispatch();
  const { benefits, loaded } = useSelector(state => state.BenefitsReducer);

  useEffect(() => {
    dispatch(fetchBenefits());
  }, []);

  if (!loaded) {
    return <TLoading />;
  }

  const hb = filter(benefits, (benefit => benefit.HrBenefitType === 0));
  if (!hb || !hb.length) {
    return <TMessage message="tile.benefits.empty" />;
  }

  return (
    <div style={styles.container}>
      <div style={{ maxHeight: 422, overflow: 'auto', height: '100%' }}>
        {map(hb, (benefit, key) => (
          <div key={key}>
            <ListItem
              innerDivStyle={styles.link}
              primaryText={benefit.HrBenefitName}
              hoverColor="transparent"
              onClick={() => dispatch(push('/benefits'))}
            />
            <Divider key="div" style={styles.spacer} />
          </div>
          ))}
      </div>
      <KFlatButton
        style={styles.actionButton}
        onClick={() => dispatch(push('/benefits'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.holiday.goto" />}
        data-cy="benefits-button"
      />
    </div>
  );
};

export default TBenefits;



// WEBPACK FOOTER //
// ./src/containers/tiles/TBenefits.js